import { makeStyles } from "@material-ui/core"

type StylesProps = {
	openDrawer: boolean,
	isTrial: boolean
}

const maxHeightGap = "130 px"

const useStyles = makeStyles({
	routesContainer: {
		height: "100%",
		maxHeight: (props: StylesProps) => props.isTrial ? `calc(100vh - ${maxHeightGap})` : "calc(100vh)",
		overflow: (props: StylesProps) => props.openDrawer ? "hidden" : "auto",
		flex: 1
	},
	routesContent: {
		height: "100%",
		maxWidth: 1096
	},
	adminContainer: {
		height: "100%"
	}
})

export default useStyles
